// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pose-skeleton-overlay {
  display: block;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.pose-skeleton-overlay-wrap {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 3;
  /* Same box + origin as the <video> so flip/rotate stay locked to pixels. */
  transform-origin: center center;
}

/* Above the idle annotation canvas (z-index 6), below draw mode (45). */
.pose-skeleton-overlay-wrap--angles {
  z-index: 8;
}

.ball-track-overlay-wrap {
  z-index: 4;
}

.pose-angles-panel {
  position: absolute;
  left: 10px;
  right: 10px;
  bottom: 10px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 12px;
  pointer-events: none;
  z-index: 4;
}

/* Sit above transport controls so angle cards never cover scrubber / play. */
.review-video-player--controls-visible .pose-angles-panel {
  bottom: 78px;
}

.review-video-player--embedded.review-video-player--controls-visible
  .pose-angles-panel {
  bottom: 64px;
}

.pose-angles-panel__block {
  margin: 0;
  padding: 8px 10px;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.72);
  color: #f5f5f5;
  font-size: 11px;
  line-height: 1.35;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  min-width: 120px;
  max-width: min(46%, 240px);
  backdrop-filter: blur(6px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35);
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.pose-angles-panel__title {
  font-weight: 700;
  letter-spacing: 0.01em;
  color: #f8fafc;
}

.pose-angles-panel__angles {
  margin: 0;
  white-space: pre;
  font: inherit;
  color: inherit;
}

.pose-angles-panel__angles--solo {
  white-space: pre;
}

.pose-angles-panel__phase {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 3px 7px;
  border-radius: 999px;
  border: 1px solid rgba(248, 250, 252, 0.18);
  background: rgba(248, 250, 252, 0.08);
  width: fit-content;
  max-width: 100%;
}

.pose-angles-panel__phase-label {
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  opacity: 0.85;
  flex-shrink: 0;
}

.pose-angles-panel__phase-value {
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pose-angles-panel__phase--preparation {
  background: rgba(56, 189, 248, 0.22);
  border-color: rgba(56, 189, 248, 0.72);
  color: #e0f2fe;
}

.pose-angles-panel__phase--forward_swing {
  background: rgba(251, 191, 36, 0.2);
  border-color: rgba(251, 191, 36, 0.72);
  color: #fef3c7;
}

.pose-angles-panel__phase--contact {
  background: rgba(251, 146, 60, 0.28);
  border-color: rgba(251, 146, 60, 0.9);
  color: #ffedd5;
}

.pose-angles-panel__phase--follow_through {
  background: rgba(255, 64, 129, 0.2);
  border-color: rgba(255, 64, 129, 0.72);
  color: #fce7f3;
}

.pose-angles-panel__phase--recovery {
  background: rgba(34, 197, 94, 0.2);
  border-color: rgba(34, 197, 94, 0.68);
  color: #dcfce7;
}

.pose-angles-panel__block--left {
  border-left: 3px solid #00bcd4;
  order: 1;
}

.pose-angles-panel__block--right {
  border-left: 3px solid #ff4081;
  order: 2;
  margin-left: auto;
}

.pose-processing-overlay {
  position: absolute;
  inset: 0;
  z-index: 6;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.45);
  pointer-events: all;
}

.pose-processing-overlay__card {
  width: min(320px, 86vw);
  padding: 18px 20px;
  border-radius: 14px;
  background: rgba(18, 18, 22, 0.92);
  color: #fff;
  text-align: center;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35);
}

.pose-processing-overlay__spinner {
  animation: pose-spin 0.9s linear infinite;
  color: #7dd3fc;
  margin-bottom: 10px;
}

@keyframes pose-spin {
  to {
    transform: rotate(360deg);
  }
}

.pose-processing-overlay__message {
  margin: 0 0 12px;
  font-size: 14px;
  font-weight: 600;
}

.pose-processing-overlay__bar-track {
  height: 8px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.15);
  overflow: hidden;
}

.pose-processing-overlay__bar-fill {
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #38bdf8, #22d3ee);
  transition: width 0.35s ease;
}

.pose-processing-overlay__meta {
  margin: 10px 0 0;
  font-size: 12px;
  opacity: 0.85;
}

.table-calib-overlay {
  position: absolute;
  inset: 0;
  z-index: 50;
  display: block;
  background: rgba(0, 0, 0, 0.28);
  pointer-events: all;
}

/* Draw layer lives inside the zoom transform with the video. */
.table-calib-overlay--draw {
  z-index: 5;
  background: rgba(0, 0, 0, 0.18);
}

.table-calib-overlay__stage {
  position: absolute;
  inset: 0;
  touch-action: none;
  cursor: crosshair;
  pointer-events: all;
}

/* Matches <video> box: transform on full frame, contain drawn in local coords. */
.table-calib-overlay__orient {
  position: absolute;
  inset: 0;
  transform-origin: center center;
}

.table-calib-overlay__video-layer {
  overflow: hidden;
  pointer-events: none;
}

.table-calib-overlay__video-layer .table-calib-overlay__svg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.table-calib-overlay__svg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

/* Must beat \`.video-layer .svg { pointer-events: none }\` or taps never register. */
.table-calib-overlay__video-layer .table-calib-overlay__svg--hit,
.table-calib-overlay__svg--hit {
  pointer-events: all !important;
  touch-action: none;
  cursor: crosshair;
}

/* Toolbar host sits on the viewport (outside zoom) so controls stay readable. */
.table-calib-overlay__toolbar-host {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 60;
  pointer-events: none;
}

.table-calib-overlay__toolbar-fallback {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 60;
  pointer-events: none;
}

.table-calib-overlay__toolbar-fallback .table-calib-overlay__toolbar {
  pointer-events: auto;
}

.table-calib-overlay__toolbar {
  position: relative;
  z-index: 2;
  padding: 10px 14px calc(14px + env(safe-area-inset-bottom, 0px));
  background: rgba(12, 12, 16, 0.94);
  color: #fff;
  pointer-events: auto;
  box-shadow: 0 -8px 24px rgba(0, 0, 0, 0.35);
}

.table-calib-overlay__hint {
  margin: 0 0 8px;
  font-size: 13px;
}

.table-calib-overlay__error {
  margin: 0 0 8px;
  color: #fca5a5;
  font-size: 12px;
}

.table-calib-overlay__actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.table-calib-overlay__btn {
  border: 1px solid rgba(255, 255, 255, 0.25);
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 13px;
  cursor: pointer;
}

.table-calib-overlay__btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.table-calib-overlay__btn--primary {
  background: #0ea5e9;
  border-color: #0ea5e9;
  font-weight: 600;
}

.review-video-player__pose-tools {
  display: flex;
  gap: 6px;
  align-items: center;
  flex-wrap: wrap;
}

.review-video-player__pose-frame-n {
  font-size: 9px;
  font-weight: 700;
  opacity: 0.9;
}

.review-video-player__pose-range {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid rgba(56, 189, 248, 0.45);
  background: rgba(14, 165, 233, 0.2);
  color: #e0f2fe;
  border-radius: 8px;
  padding: 6px 8px;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
}

.review-video-player__pose-range:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.review-video-player__scrubber-wrap {
  position: relative;
  flex: 1 1;
  min-width: 0;
  display: flex;
  align-items: center;
}

.review-video-player__scrubber-range {
  position: absolute;
  left: 0;
  right: 0;
  height: 4px;
  border-radius: 999px;
  pointer-events: none;
  z-index: 0;
}

.review-video-player__scrubber-range-fill {
  position: absolute;
  top: 0;
  bottom: 0;
  background: rgba(56, 189, 248, 0.55);
  border-radius: inherit;
}

.review-video-player__scrubber-range--kot {
  top: 50%;
  transform: translateY(-50%);
}

.review-video-player__scrubber-kot-point {
  position: absolute;
  top: 0;
  bottom: 0;
  background: rgba(74, 222, 128, 0.45);
  border-radius: inherit;
}

.review-video-player__kot-points {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  justify-content: center;
  width: 100%;
  margin: 4px 0 2px;
  padding: 0 4px;
}

.review-video-player__kot-point-chip {
  min-width: 28px;
  height: 26px;
  padding: 0 8px;
  border: 1px solid rgba(255, 255, 255, 0.28);
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.35);
  color: rgba(255, 255, 255, 0.92);
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
}

.review-video-player__kot-point-chip--active {
  border-color: rgba(74, 222, 128, 0.9);
  background: rgba(22, 101, 52, 0.75);
}

.review-video-player__kot-points-hint {
  margin: 2px 0 4px;
  padding: 0 8px;
  font-size: 11px;
  line-height: 1.35;
  text-align: center;
  color: rgba(255, 255, 255, 0.65);
}

.review-video-player__kot-source-badge {
  margin: 0 0 4px;
  padding: 0 8px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  text-align: center;
  color: rgba(134, 239, 172, 0.9);
}

.review-video-player__game-points {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  margin: 6px 0 4px;
  padding: 0 4px;
}

.review-video-player__btn--game-points {
  min-width: 128px;
  flex-direction: row;
  gap: 8px;
  padding: 8px 14px;
  border-radius: 999px;
}

.review-video-player__btn--game-points span {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  opacity: 1;
}

.review-video-player__btn--game-points-on {
  background: rgba(22, 101, 52, 0.88);
  box-shadow: inset 0 0 0 1px rgba(74, 222, 128, 0.9);
  color: #ecfdf3;
}

.review-video-player__btn--game-points-blocked {
  opacity: 0.55;
}

.review-video-player__btn--point-skip {
  min-width: 48px;
}

.player-calib-overlay__skeleton-canvas {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 2;
}


.player-calib-overlay__sides {
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
}

.player-calib-overlay__side-btn {
  flex: 1 1;
  border: 1px solid rgba(255, 255, 255, 0.25);
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  border-radius: 8px;
  padding: 8px 10px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.player-calib-overlay__side-btn.is-active.is-left {
  background: rgba(0, 188, 212, 0.35);
  border-color: #00bcd4;
}

.player-calib-overlay__side-btn.is-active.is-right {
  background: rgba(255, 64, 129, 0.35);
  border-color: #ff4081;
}

.player-calib-overlay__side-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.review-video-player__btn--pose-active {
  background: rgba(14, 165, 233, 0.35) !important;
  border-color: #38bdf8 !important;
}

.pose-angle-charts {
  position: relative;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 12px 6px;
  background: rgba(8, 10, 14, 0.96);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  overscroll-behavior: contain;
  z-index: 30;
  pointer-events: auto;
  max-height: min(48vh, 420px);
  overflow-y: auto;
}

.pose-angle-charts--top {
  order: -1;
}

.pose-angle-charts__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 18px;
}

.pose-angle-charts__panel {
  width: 100%;
}

.pose-angle-charts__title {
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: rgba(248, 250, 252, 0.72);
}

.pose-angle-charts__subtitle {
  margin: 0 0 2px;
  font-size: 10px;
  font-weight: 600;
  color: rgba(248, 250, 252, 0.55);
}

.pose-angle-charts__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.pose-angle-charts__hint {
  font-size: 10px;
  color: rgba(248, 250, 252, 0.42);
}

.pose-angle-charts__reset {
  appearance: none;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.08);
  color: rgba(248, 250, 252, 0.9);
  font-size: 10px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 6px;
  cursor: pointer;
}

.pose-angle-charts__reset:hover {
  background: rgba(255, 255, 255, 0.14);
}

.pose-angle-charts__curve-toggles {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 2px 0 4px;
}

.pose-angle-charts__curve-toggles,
.pose-angle-charts__stroke-select,
.pose-angle-charts__stroke-chips {
  position: relative;
  z-index: 2;
  pointer-events: auto;
}

.pose-angle-charts__select-label {
  display: inline-flex;
  align-items: center;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgba(248, 250, 252, 0.48);
  margin-right: 2px;
}

.pose-angle-charts__curve-btn {
  appearance: none;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: rgba(255, 255, 255, 0.06);
  color: rgba(248, 250, 252, 0.88);
  font-size: 10px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 999px;
  cursor: pointer;
  pointer-events: auto;
  position: relative;
  z-index: 1;
}

.pose-angle-charts__curve-btn.is-on {
  border-color: color-mix(in srgb, var(--curve-color) 70%, transparent);
  background: color-mix(in srgb, var(--curve-color) 22%, transparent);
}

.pose-angle-charts__curve-btn.is-off {
  opacity: 0.45;
}

.pose-angle-charts__stroke-select {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 0 0 6px;
}

.pose-angle-charts__stroke-count {
  font-variant-numeric: tabular-nums;
  opacity: 0.75;
  font-weight: 700;
}

.pose-angle-charts__params {
  margin: 0 0 6px;
  padding: 7px 10px;
  border-radius: 8px;
  background: rgba(15, 23, 42, 0.65);
  border: 1px solid rgba(148, 163, 184, 0.28);
}

.pose-angle-charts__params-title {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgba(226, 232, 240, 0.72);
  margin-bottom: 4px;
}

.pose-angle-charts__params-list {
  margin: 0;
  padding-left: 16px;
  font-size: 11px;
  line-height: 1.45;
  color: rgba(248, 250, 252, 0.78);
}

.pose-angle-charts__stroke-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin: 0 0 6px;
  max-height: 96px;
  overflow-y: auto;
}

.pose-angle-charts__stroke-chip {
  appearance: none;
  min-width: 32px;
  border: 1px solid color-mix(in srgb, var(--curve-color) 45%, transparent);
  background: color-mix(in srgb, var(--curve-color) 12%, transparent);
  color: rgba(248, 250, 252, 0.92);
  font-size: 10px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 999px;
  cursor: pointer;
}

.pose-angle-charts__stroke-chip:hover {
  background: color-mix(in srgb, var(--curve-color) 22%, transparent);
}

.pose-angle-charts__stroke-chip.is-on {
  background: color-mix(in srgb, var(--curve-color) 38%, transparent);
  border-color: var(--curve-color);
  box-shadow: 0 0 0 1px color-mix(in srgb, var(--curve-color) 50%, transparent);
}

.pose-angle-charts__stroke-chip:focus-visible {
  outline: 2px solid var(--curve-color);
  outline-offset: 1px;
}

.pose-angle-charts__stroke-detail {
  margin: 0 0 8px;
  padding: 8px 10px;
  border-radius: 10px;
  background: rgba(8, 15, 28, 0.78);
  border: 1px solid rgba(56, 189, 248, 0.32);
}

.pose-angle-charts__stroke-detail-grid {
  display: grid;
  grid-template-columns: auto 1fr auto 1fr;
  gap: 3px 10px;
  font-size: 11px;
  color: rgba(248, 250, 252, 0.62);
  margin-bottom: 6px;
}

.pose-angle-charts__stroke-detail-grid strong {
  color: rgba(248, 250, 252, 0.94);
  font-weight: 650;
}

.pose-angle-charts__stroke-phases {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.pose-angle-charts__stroke-phase {
  font-size: 10px;
  font-weight: 650;
  padding: 2px 7px;
  border-radius: 999px;
  color: rgba(248, 250, 252, 0.9);
  background: rgba(255, 255, 255, 0.08);
}

.pose-angle-charts__stroke-phase--preparation {
  background: rgba(56, 189, 248, 0.22);
}

.pose-angle-charts__stroke-phase--forward_swing {
  background: rgba(251, 191, 36, 0.22);
}

.pose-angle-charts__stroke-phase--contact {
  background: rgba(251, 146, 60, 0.28);
}

.pose-angle-charts__stroke-phase--follow_through {
  background: rgba(255, 64, 129, 0.2);
}

.pose-angle-charts__stroke-phase--recovery {
  background: rgba(34, 197, 94, 0.2);
}

.pose-angle-charts__curve-swatch {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.pose-angle-charts__stroke-legend {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 10px;
  margin: 0 0 8px;
  padding: 6px 8px;
  border-radius: 8px;
  background: rgba(251, 146, 60, 0.08);
  border: 1px solid rgba(251, 146, 60, 0.22);
  font-size: 11px;
  color: rgba(248, 250, 252, 0.72);
}

.pose-angle-charts__stroke-swatch {
  display: inline-block;
  width: 18px;
  height: 0;
  border-top: 2px solid #fb923c;
  flex-shrink: 0;
}

.pose-angle-charts__stroke-swatch--fh {
  border-top-color: #38bdf8;
}

.pose-angle-charts__stroke-swatch--bh {
  border-top-color: #a78bfa;
}

.pose-angle-charts__stroke-swatch--serve {
  border-top-color: #fb7185;
  border-top-style: dashed;
}

.pose-angle-charts__stroke-swatch--serve-a {
  border-top-color: #00bcd4;
  border-top-style: dashed;
}

.pose-angle-charts__stroke-swatch--serve-b {
  border-top-color: #ff4081;
  border-top-style: dashed;
}

.pose-angle-charts__stroke-swatch--angle {
  border-top-style: dashed;
  border-top-color: rgba(251, 146, 60, 0.65);
}

.pose-angle-charts__stroke-swatch--trial {
  height: 10px;
  width: 18px;
  border-top: none;
  border-radius: 2px;
  background: rgba(168, 85, 247, 0.35);
  border: 1px solid rgba(216, 180, 254, 0.9);
  box-sizing: border-box;
}

.pose-angle-charts__stroke-swatch--rally {
  height: 10px;
  width: 18px;
  border-top: none;
  border-radius: 2px;
  background: rgba(147, 51, 234, 0.55);
  border: 1px solid #e9d5ff;
  box-sizing: border-box;
}

.pose-angle-charts__phase-swatch {
  height: 10px;
  width: 18px;
  border-radius: 2px;
  display: inline-block;
  flex-shrink: 0;
  border: 1px solid rgba(248, 250, 252, 0.18);
  background: rgba(248, 250, 252, 0.08);
  box-sizing: border-box;
}

.pose-angle-charts__phase-swatch--preparation {
  background: rgba(56, 189, 248, 0.18);
  border-color: rgba(56, 189, 248, 0.68);
}

.pose-angle-charts__phase-swatch--forward {
  background: rgba(251, 191, 36, 0.16);
  border-color: rgba(251, 191, 36, 0.68);
}

.pose-angle-charts__phase-swatch--contact {
  background: rgba(251, 146, 60, 0.20);
  border-color: rgba(251, 146, 60, 0.88);
}

.pose-angle-charts__phase-swatch--follow {
  background: rgba(255, 64, 129, 0.14);
  border-color: rgba(255, 64, 129, 0.66);
}

.pose-angle-charts__phase-swatch--recovery {
  background: rgba(34, 197, 94, 0.12);
  border-color: rgba(34, 197, 94, 0.62);
}

.pose-angle-charts__empty {
  margin: 4px 0 0;
  font-size: 11px;
  color: rgba(248, 250, 252, 0.5);
}

.pose-angle-charts__tooltip {
  padding: 6px 8px;
  border-radius: 8px;
  background: rgba(12, 12, 16, 0.94);
  border: 1px solid rgba(255, 255, 255, 0.12);
  font-size: 11px;
  color: #f8fafc;
}

.pose-angle-charts__tooltip-time {
  margin-bottom: 4px;
  font-weight: 600;
  color: rgba(248, 250, 252, 0.85);
}

.pose-angle-charts__tooltip-phase {
  margin: 0 0 6px;
  font-weight: 700;
  font-size: 11px;
  letter-spacing: 0.01em;
}

.pose-angle-charts__tooltip-phase--preparation {
  color: #7dd3fc;
}

.pose-angle-charts__tooltip-phase--forward_swing {
  color: #fbbf24;
}

.pose-angle-charts__tooltip-phase--contact {
  color: #fb923c;
}

.pose-angle-charts__tooltip-phase--follow_through {
  color: #f472b6;
}

.pose-angle-charts__tooltip-phase--recovery {
  color: #4ade80;
}

.review-video-player--embedded .pose-angle-charts {
  max-height: min(36vh, 280px);
}

.pose-detection-metrics {
  margin: 0 0 8px;
  padding: 8px 10px;
  border-radius: 10px;
  background: rgba(15, 23, 42, 0.72);
  border: 1px solid rgba(251, 191, 36, 0.35);
}

.pose-detection-metrics__title {
  font-size: 12px;
  font-weight: 650;
  color: #fde68a;
  margin-bottom: 6px;
}

.pose-detection-metrics__grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 6px;
}

.pose-detection-metrics__stat {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.pose-detection-metrics__label {
  font-size: 9px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: rgba(248, 250, 252, 0.5);
}

.pose-detection-metrics__value {
  font-size: 13px;
  font-weight: 650;
  color: #f8fafc;
  font-variant-numeric: tabular-nums;
}

.pose-detection-metrics__hint {
  margin: 6px 0 0;
  font-size: 10px;
  color: rgba(248, 250, 252, 0.45);
  line-height: 1.35;
}

.serve-bounce-heatmap {
  margin: 8px 0 4px;
  border-radius: 10px;
  overflow: hidden;
  background: linear-gradient(180deg, rgba(8, 15, 28, 0.92), rgba(15, 23, 42, 0.88));
  border: 1px solid rgba(148, 163, 184, 0.18);
}

.serve-bounce-heatmap__svg {
  display: block;
  width: 100%;
  height: auto;
  max-height: 140px;
}

.serve-bounce-heatmap__caption {
  margin: 0;
  padding: 4px 8px 8px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: rgba(226, 232, 240, 0.78);
}

.serve-heat-map {
  margin: 8px 0 4px;
  border-radius: 10px;
  overflow: hidden;
  background: linear-gradient(180deg, rgba(8, 15, 28, 0.92), rgba(15, 23, 42, 0.88));
  border: 1px solid rgba(148, 163, 184, 0.18);
}

.serve-heat-map__svg {
  display: block;
  width: 100%;
  height: auto;
  max-height: 168px;
}

.serve-heat-map__floor {
  fill: #0b1220;
}

.serve-heat-map__table {
  fill: #1d4a38;
  stroke: rgba(167, 243, 208, 0.55);
  stroke-width: 1.4;
}

.serve-heat-map__stand {
  fill: rgba(15, 23, 42, 0.35);
}

.serve-heat-map__stand--a {
  fill: rgba(34, 211, 238, 0.08);
}

.serve-heat-map__stand--b {
  fill: rgba(251, 113, 133, 0.08);
}

.serve-heat-map__net {
  stroke: #f8fafc;
  stroke-width: 1.6;
  stroke-linecap: round;
  opacity: 0.85;
}

.serve-heat-map__bin--a {
  fill: #22d3ee;
  pointer-events: none;
}

.serve-heat-map__bin--b {
  fill: #fb7185;
  pointer-events: none;
}

.serve-heat-map__dot circle {
  fill: #22d3ee;
  stroke: rgba(8, 15, 28, 0.85);
  stroke-width: 1.2;
  cursor: pointer;
  outline: none;
}

.serve-heat-map__dot.is-b circle {
  fill: #fb7185;
}

.serve-heat-map__dot.is-selected circle {
  stroke: #fef3c7;
  stroke-width: 2;
  filter: drop-shadow(0 0 4px rgba(253, 230, 138, 0.8));
}

.serve-heat-map__dot circle:focus-visible {
  stroke: #f8fafc;
  stroke-width: 2.2;
}

.serve-heat-map__end-label {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.04em;
  pointer-events: none;
}

.serve-heat-map__end-label--a {
  fill: #67e8f9;
}

.serve-heat-map__end-label--b {
  fill: #fda4af;
}

.serve-heat-map__dot-ms {
  fill: #f8fafc;
  font-size: 9px;
  font-weight: 700;
  paint-order: stroke;
  stroke: rgba(8, 15, 28, 0.85);
  stroke-width: 2.4;
  pointer-events: none;
}

.serve-ready-list {
  list-style: none;
  margin: 8px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: 168px;
  overflow-y: auto;
}

.serve-ready-list__row {
  appearance: none;
  width: 100%;
  display: grid;
  grid-template-columns: 52px 1fr auto;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  border-radius: 8px;
  border: 1px solid rgba(148, 163, 184, 0.16);
  background: rgba(8, 15, 28, 0.45);
  color: inherit;
  cursor: pointer;
  text-align: left;
}

.serve-ready-list__row:hover {
  background: rgba(8, 15, 28, 0.72);
}

.serve-ready-list__row:focus-visible {
  outline: 2px solid #67e8f9;
  outline-offset: 1px;
}

.serve-ready-list__row.is-a {
  border-left: 3px solid #22d3ee;
}

.serve-ready-list__row.is-b {
  border-left: 3px solid #fb7185;
}

.serve-ready-list__row.is-on {
  background: rgba(251, 191, 36, 0.12);
  border-color: rgba(251, 191, 36, 0.45);
}

.serve-ready-list__id {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.02em;
  color: #e2e8f0;
}

.serve-ready-list__metric-label {
  font-size: 10px;
  color: rgba(248, 250, 252, 0.5);
}

.serve-ready-list__value {
  font-size: 13px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: #f8fafc;
}

@media (max-width: 640px) {
  .pose-detection-metrics__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/pose/poseOverlays.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,2EAA2E;EAC3E,+BAA+B;AACjC;;AAEA,wEAAwE;AACxE;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,UAAU;AACZ;;AAEA,6EAA6E;AAC7E;EACE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,6EAA6E;EAC7E,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;EAC1B,0CAA0C;EAC1C,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,2CAA2C;EAC3C,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,WAAW;EACX,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,oDAAoD;EACpD,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,cAAc;EACd,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA,+DAA+D;AAC/D;EACE,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,iFAAiF;AACjF;EACE,kBAAkB;EAClB,QAAQ;EACR,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA,mFAAmF;AACnF;;EAEE,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,gFAAgF;AAChF;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gEAAgE;EAChE,kCAAkC;EAClC,WAAW;EACX,oBAAoB;EACpB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,qCAAqC;EACrC,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,0CAA0C;EAC1C,mCAAmC;EACnC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oBAAoB;EACpB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,2CAA2C;EAC3C,oBAAoB;EACpB,+BAA+B;EAC/B,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,mDAAmD;EACnD,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;AACZ;;;AAGA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,2CAA2C;EAC3C,qCAAqC;EACrC,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;EAC/C,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,qBAAqB;EACrB,iCAAiC;EACjC,kDAAkD;EAClD,4BAA4B;EAC5B,WAAW;EACX,oBAAoB;EACpB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;EAC3C,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,iBAAiB;AACnB;;AAEA;;;EAGE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,2CAA2C;EAC3C,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,qEAAqE;EACrE,mEAAmE;AACrE;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yEAAyE;EACzE,mEAAmE;EACnE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,mEAAmE;EACnE,gCAAgC;EAChC,6EAA6E;AAC/E;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,iCAAiC;EACjC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,aAAa;EACb,eAAe;EACf,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,0CAA0C;EAC1C,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,SAAS;EACT,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,0CAA0C;EAC1C,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,2CAA2C;EAC3C,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,2CAA2C;EAC3C,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kFAAkF;EAClF,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kFAAkF;EAClF,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF","sourcesContent":[".pose-skeleton-overlay {\n  display: block;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n}\n\n.pose-skeleton-overlay-wrap {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: 3;\n  /* Same box + origin as the <video> so flip/rotate stay locked to pixels. */\n  transform-origin: center center;\n}\n\n/* Above the idle annotation canvas (z-index 6), below draw mode (45). */\n.pose-skeleton-overlay-wrap--angles {\n  z-index: 8;\n}\n\n.ball-track-overlay-wrap {\n  z-index: 4;\n}\n\n.pose-angles-panel {\n  position: absolute;\n  left: 10px;\n  right: 10px;\n  bottom: 10px;\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 12px;\n  pointer-events: none;\n  z-index: 4;\n}\n\n/* Sit above transport controls so angle cards never cover scrubber / play. */\n.review-video-player--controls-visible .pose-angles-panel {\n  bottom: 78px;\n}\n\n.review-video-player--embedded.review-video-player--controls-visible\n  .pose-angles-panel {\n  bottom: 64px;\n}\n\n.pose-angles-panel__block {\n  margin: 0;\n  padding: 8px 10px;\n  border-radius: 10px;\n  background: rgba(0, 0, 0, 0.72);\n  color: #f5f5f5;\n  font-size: 11px;\n  line-height: 1.35;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  min-width: 120px;\n  max-width: min(46%, 240px);\n  backdrop-filter: blur(6px);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35);\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.pose-angles-panel__title {\n  font-weight: 700;\n  letter-spacing: 0.01em;\n  color: #f8fafc;\n}\n\n.pose-angles-panel__angles {\n  margin: 0;\n  white-space: pre;\n  font: inherit;\n  color: inherit;\n}\n\n.pose-angles-panel__angles--solo {\n  white-space: pre;\n}\n\n.pose-angles-panel__phase {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 3px 7px;\n  border-radius: 999px;\n  border: 1px solid rgba(248, 250, 252, 0.18);\n  background: rgba(248, 250, 252, 0.08);\n  width: fit-content;\n  max-width: 100%;\n}\n\n.pose-angles-panel__phase-label {\n  font-size: 9px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  opacity: 0.85;\n  flex-shrink: 0;\n}\n\n.pose-angles-panel__phase-value {\n  font-size: 11px;\n  font-weight: 700;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.pose-angles-panel__phase--preparation {\n  background: rgba(56, 189, 248, 0.22);\n  border-color: rgba(56, 189, 248, 0.72);\n  color: #e0f2fe;\n}\n\n.pose-angles-panel__phase--forward_swing {\n  background: rgba(251, 191, 36, 0.2);\n  border-color: rgba(251, 191, 36, 0.72);\n  color: #fef3c7;\n}\n\n.pose-angles-panel__phase--contact {\n  background: rgba(251, 146, 60, 0.28);\n  border-color: rgba(251, 146, 60, 0.9);\n  color: #ffedd5;\n}\n\n.pose-angles-panel__phase--follow_through {\n  background: rgba(255, 64, 129, 0.2);\n  border-color: rgba(255, 64, 129, 0.72);\n  color: #fce7f3;\n}\n\n.pose-angles-panel__phase--recovery {\n  background: rgba(34, 197, 94, 0.2);\n  border-color: rgba(34, 197, 94, 0.68);\n  color: #dcfce7;\n}\n\n.pose-angles-panel__block--left {\n  border-left: 3px solid #00bcd4;\n  order: 1;\n}\n\n.pose-angles-panel__block--right {\n  border-left: 3px solid #ff4081;\n  order: 2;\n  margin-left: auto;\n}\n\n.pose-processing-overlay {\n  position: absolute;\n  inset: 0;\n  z-index: 6;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.45);\n  pointer-events: all;\n}\n\n.pose-processing-overlay__card {\n  width: min(320px, 86vw);\n  padding: 18px 20px;\n  border-radius: 14px;\n  background: rgba(18, 18, 22, 0.92);\n  color: #fff;\n  text-align: center;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35);\n}\n\n.pose-processing-overlay__spinner {\n  animation: pose-spin 0.9s linear infinite;\n  color: #7dd3fc;\n  margin-bottom: 10px;\n}\n\n@keyframes pose-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.pose-processing-overlay__message {\n  margin: 0 0 12px;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.pose-processing-overlay__bar-track {\n  height: 8px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.15);\n  overflow: hidden;\n}\n\n.pose-processing-overlay__bar-fill {\n  height: 100%;\n  border-radius: inherit;\n  background: linear-gradient(90deg, #38bdf8, #22d3ee);\n  transition: width 0.35s ease;\n}\n\n.pose-processing-overlay__meta {\n  margin: 10px 0 0;\n  font-size: 12px;\n  opacity: 0.85;\n}\n\n.table-calib-overlay {\n  position: absolute;\n  inset: 0;\n  z-index: 50;\n  display: block;\n  background: rgba(0, 0, 0, 0.28);\n  pointer-events: all;\n}\n\n/* Draw layer lives inside the zoom transform with the video. */\n.table-calib-overlay--draw {\n  z-index: 5;\n  background: rgba(0, 0, 0, 0.18);\n}\n\n.table-calib-overlay__stage {\n  position: absolute;\n  inset: 0;\n  touch-action: none;\n  cursor: crosshair;\n  pointer-events: all;\n}\n\n/* Matches <video> box: transform on full frame, contain drawn in local coords. */\n.table-calib-overlay__orient {\n  position: absolute;\n  inset: 0;\n  transform-origin: center center;\n}\n\n.table-calib-overlay__video-layer {\n  overflow: hidden;\n  pointer-events: none;\n}\n\n.table-calib-overlay__video-layer .table-calib-overlay__svg {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n}\n\n.table-calib-overlay__svg {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n}\n\n/* Must beat `.video-layer .svg { pointer-events: none }` or taps never register. */\n.table-calib-overlay__video-layer .table-calib-overlay__svg--hit,\n.table-calib-overlay__svg--hit {\n  pointer-events: all !important;\n  touch-action: none;\n  cursor: crosshair;\n}\n\n/* Toolbar host sits on the viewport (outside zoom) so controls stay readable. */\n.table-calib-overlay__toolbar-host {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 60;\n  pointer-events: none;\n}\n\n.table-calib-overlay__toolbar-fallback {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 60;\n  pointer-events: none;\n}\n\n.table-calib-overlay__toolbar-fallback .table-calib-overlay__toolbar {\n  pointer-events: auto;\n}\n\n.table-calib-overlay__toolbar {\n  position: relative;\n  z-index: 2;\n  padding: 10px 14px calc(14px + env(safe-area-inset-bottom, 0px));\n  background: rgba(12, 12, 16, 0.94);\n  color: #fff;\n  pointer-events: auto;\n  box-shadow: 0 -8px 24px rgba(0, 0, 0, 0.35);\n}\n\n.table-calib-overlay__hint {\n  margin: 0 0 8px;\n  font-size: 13px;\n}\n\n.table-calib-overlay__error {\n  margin: 0 0 8px;\n  color: #fca5a5;\n  font-size: 12px;\n}\n\n.table-calib-overlay__actions {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.table-calib-overlay__btn {\n  border: 1px solid rgba(255, 255, 255, 0.25);\n  background: rgba(255, 255, 255, 0.08);\n  color: #fff;\n  border-radius: 8px;\n  padding: 8px 12px;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.table-calib-overlay__btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.table-calib-overlay__btn--primary {\n  background: #0ea5e9;\n  border-color: #0ea5e9;\n  font-weight: 600;\n}\n\n.review-video-player__pose-tools {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.review-video-player__pose-frame-n {\n  font-size: 9px;\n  font-weight: 700;\n  opacity: 0.9;\n}\n\n.review-video-player__pose-range {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: 1px solid rgba(56, 189, 248, 0.45);\n  background: rgba(14, 165, 233, 0.2);\n  color: #e0f2fe;\n  border-radius: 8px;\n  padding: 6px 8px;\n  font-size: 11px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.review-video-player__pose-range:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.review-video-player__scrubber-wrap {\n  position: relative;\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n}\n\n.review-video-player__scrubber-range {\n  position: absolute;\n  left: 0;\n  right: 0;\n  height: 4px;\n  border-radius: 999px;\n  pointer-events: none;\n  z-index: 0;\n}\n\n.review-video-player__scrubber-range-fill {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  background: rgba(56, 189, 248, 0.55);\n  border-radius: inherit;\n}\n\n.review-video-player__scrubber-range--kot {\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.review-video-player__scrubber-kot-point {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  background: rgba(74, 222, 128, 0.45);\n  border-radius: inherit;\n}\n\n.review-video-player__kot-points {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  justify-content: center;\n  width: 100%;\n  margin: 4px 0 2px;\n  padding: 0 4px;\n}\n\n.review-video-player__kot-point-chip {\n  min-width: 28px;\n  height: 26px;\n  padding: 0 8px;\n  border: 1px solid rgba(255, 255, 255, 0.28);\n  border-radius: 999px;\n  background: rgba(0, 0, 0, 0.35);\n  color: rgba(255, 255, 255, 0.92);\n  font-size: 11px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.review-video-player__kot-point-chip--active {\n  border-color: rgba(74, 222, 128, 0.9);\n  background: rgba(22, 101, 52, 0.75);\n}\n\n.review-video-player__kot-points-hint {\n  margin: 2px 0 4px;\n  padding: 0 8px;\n  font-size: 11px;\n  line-height: 1.35;\n  text-align: center;\n  color: rgba(255, 255, 255, 0.65);\n}\n\n.review-video-player__kot-source-badge {\n  margin: 0 0 4px;\n  padding: 0 8px;\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  text-align: center;\n  color: rgba(134, 239, 172, 0.9);\n}\n\n.review-video-player__game-points {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  margin: 6px 0 4px;\n  padding: 0 4px;\n}\n\n.review-video-player__btn--game-points {\n  min-width: 128px;\n  flex-direction: row;\n  gap: 8px;\n  padding: 8px 14px;\n  border-radius: 999px;\n}\n\n.review-video-player__btn--game-points span {\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  opacity: 1;\n}\n\n.review-video-player__btn--game-points-on {\n  background: rgba(22, 101, 52, 0.88);\n  box-shadow: inset 0 0 0 1px rgba(74, 222, 128, 0.9);\n  color: #ecfdf3;\n}\n\n.review-video-player__btn--game-points-blocked {\n  opacity: 0.55;\n}\n\n.review-video-player__btn--point-skip {\n  min-width: 48px;\n}\n\n.player-calib-overlay__skeleton-canvas {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: 2;\n}\n\n\n.player-calib-overlay__sides {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.player-calib-overlay__side-btn {\n  flex: 1;\n  border: 1px solid rgba(255, 255, 255, 0.25);\n  background: rgba(255, 255, 255, 0.08);\n  color: #fff;\n  border-radius: 8px;\n  padding: 8px 10px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.player-calib-overlay__side-btn.is-active.is-left {\n  background: rgba(0, 188, 212, 0.35);\n  border-color: #00bcd4;\n}\n\n.player-calib-overlay__side-btn.is-active.is-right {\n  background: rgba(255, 64, 129, 0.35);\n  border-color: #ff4081;\n}\n\n.player-calib-overlay__side-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.review-video-player__btn--pose-active {\n  background: rgba(14, 165, 233, 0.35) !important;\n  border-color: #38bdf8 !important;\n}\n\n.pose-angle-charts {\n  position: relative;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 8px 12px 6px;\n  background: rgba(8, 10, 14, 0.96);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  overscroll-behavior: contain;\n  z-index: 30;\n  pointer-events: auto;\n  max-height: min(48vh, 420px);\n  overflow-y: auto;\n}\n\n.pose-angle-charts--top {\n  order: -1;\n}\n\n.pose-angle-charts__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  min-height: 18px;\n}\n\n.pose-angle-charts__panel {\n  width: 100%;\n}\n\n.pose-angle-charts__title {\n  margin: 0;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  color: rgba(248, 250, 252, 0.72);\n}\n\n.pose-angle-charts__subtitle {\n  margin: 0 0 2px;\n  font-size: 10px;\n  font-weight: 600;\n  color: rgba(248, 250, 252, 0.55);\n}\n\n.pose-angle-charts__actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n.pose-angle-charts__hint {\n  font-size: 10px;\n  color: rgba(248, 250, 252, 0.42);\n}\n\n.pose-angle-charts__reset {\n  appearance: none;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  background: rgba(255, 255, 255, 0.08);\n  color: rgba(248, 250, 252, 0.9);\n  font-size: 10px;\n  font-weight: 600;\n  padding: 3px 8px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.pose-angle-charts__reset:hover {\n  background: rgba(255, 255, 255, 0.14);\n}\n\n.pose-angle-charts__curve-toggles {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin: 2px 0 4px;\n}\n\n.pose-angle-charts__curve-toggles,\n.pose-angle-charts__stroke-select,\n.pose-angle-charts__stroke-chips {\n  position: relative;\n  z-index: 2;\n  pointer-events: auto;\n}\n\n.pose-angle-charts__select-label {\n  display: inline-flex;\n  align-items: center;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: rgba(248, 250, 252, 0.48);\n  margin-right: 2px;\n}\n\n.pose-angle-charts__curve-btn {\n  appearance: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  background: rgba(255, 255, 255, 0.06);\n  color: rgba(248, 250, 252, 0.88);\n  font-size: 10px;\n  font-weight: 600;\n  padding: 4px 8px;\n  border-radius: 999px;\n  cursor: pointer;\n  pointer-events: auto;\n  position: relative;\n  z-index: 1;\n}\n\n.pose-angle-charts__curve-btn.is-on {\n  border-color: color-mix(in srgb, var(--curve-color) 70%, transparent);\n  background: color-mix(in srgb, var(--curve-color) 22%, transparent);\n}\n\n.pose-angle-charts__curve-btn.is-off {\n  opacity: 0.45;\n}\n\n.pose-angle-charts__stroke-select {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin: 0 0 6px;\n}\n\n.pose-angle-charts__stroke-count {\n  font-variant-numeric: tabular-nums;\n  opacity: 0.75;\n  font-weight: 700;\n}\n\n.pose-angle-charts__params {\n  margin: 0 0 6px;\n  padding: 7px 10px;\n  border-radius: 8px;\n  background: rgba(15, 23, 42, 0.65);\n  border: 1px solid rgba(148, 163, 184, 0.28);\n}\n\n.pose-angle-charts__params-title {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: rgba(226, 232, 240, 0.72);\n  margin-bottom: 4px;\n}\n\n.pose-angle-charts__params-list {\n  margin: 0;\n  padding-left: 16px;\n  font-size: 11px;\n  line-height: 1.45;\n  color: rgba(248, 250, 252, 0.78);\n}\n\n.pose-angle-charts__stroke-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px;\n  margin: 0 0 6px;\n  max-height: 96px;\n  overflow-y: auto;\n}\n\n.pose-angle-charts__stroke-chip {\n  appearance: none;\n  min-width: 32px;\n  border: 1px solid color-mix(in srgb, var(--curve-color) 45%, transparent);\n  background: color-mix(in srgb, var(--curve-color) 12%, transparent);\n  color: rgba(248, 250, 252, 0.92);\n  font-size: 10px;\n  font-weight: 700;\n  padding: 3px 8px;\n  border-radius: 999px;\n  cursor: pointer;\n}\n\n.pose-angle-charts__stroke-chip:hover {\n  background: color-mix(in srgb, var(--curve-color) 22%, transparent);\n}\n\n.pose-angle-charts__stroke-chip.is-on {\n  background: color-mix(in srgb, var(--curve-color) 38%, transparent);\n  border-color: var(--curve-color);\n  box-shadow: 0 0 0 1px color-mix(in srgb, var(--curve-color) 50%, transparent);\n}\n\n.pose-angle-charts__stroke-chip:focus-visible {\n  outline: 2px solid var(--curve-color);\n  outline-offset: 1px;\n}\n\n.pose-angle-charts__stroke-detail {\n  margin: 0 0 8px;\n  padding: 8px 10px;\n  border-radius: 10px;\n  background: rgba(8, 15, 28, 0.78);\n  border: 1px solid rgba(56, 189, 248, 0.32);\n}\n\n.pose-angle-charts__stroke-detail-grid {\n  display: grid;\n  grid-template-columns: auto 1fr auto 1fr;\n  gap: 3px 10px;\n  font-size: 11px;\n  color: rgba(248, 250, 252, 0.62);\n  margin-bottom: 6px;\n}\n\n.pose-angle-charts__stroke-detail-grid strong {\n  color: rgba(248, 250, 252, 0.94);\n  font-weight: 650;\n}\n\n.pose-angle-charts__stroke-phases {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.pose-angle-charts__stroke-phase {\n  font-size: 10px;\n  font-weight: 650;\n  padding: 2px 7px;\n  border-radius: 999px;\n  color: rgba(248, 250, 252, 0.9);\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.pose-angle-charts__stroke-phase--preparation {\n  background: rgba(56, 189, 248, 0.22);\n}\n\n.pose-angle-charts__stroke-phase--forward_swing {\n  background: rgba(251, 191, 36, 0.22);\n}\n\n.pose-angle-charts__stroke-phase--contact {\n  background: rgba(251, 146, 60, 0.28);\n}\n\n.pose-angle-charts__stroke-phase--follow_through {\n  background: rgba(255, 64, 129, 0.2);\n}\n\n.pose-angle-charts__stroke-phase--recovery {\n  background: rgba(34, 197, 94, 0.2);\n}\n\n.pose-angle-charts__curve-swatch {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.pose-angle-charts__stroke-legend {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px 10px;\n  margin: 0 0 8px;\n  padding: 6px 8px;\n  border-radius: 8px;\n  background: rgba(251, 146, 60, 0.08);\n  border: 1px solid rgba(251, 146, 60, 0.22);\n  font-size: 11px;\n  color: rgba(248, 250, 252, 0.72);\n}\n\n.pose-angle-charts__stroke-swatch {\n  display: inline-block;\n  width: 18px;\n  height: 0;\n  border-top: 2px solid #fb923c;\n  flex-shrink: 0;\n}\n\n.pose-angle-charts__stroke-swatch--fh {\n  border-top-color: #38bdf8;\n}\n\n.pose-angle-charts__stroke-swatch--bh {\n  border-top-color: #a78bfa;\n}\n\n.pose-angle-charts__stroke-swatch--serve {\n  border-top-color: #fb7185;\n  border-top-style: dashed;\n}\n\n.pose-angle-charts__stroke-swatch--serve-a {\n  border-top-color: #00bcd4;\n  border-top-style: dashed;\n}\n\n.pose-angle-charts__stroke-swatch--serve-b {\n  border-top-color: #ff4081;\n  border-top-style: dashed;\n}\n\n.pose-angle-charts__stroke-swatch--angle {\n  border-top-style: dashed;\n  border-top-color: rgba(251, 146, 60, 0.65);\n}\n\n.pose-angle-charts__stroke-swatch--trial {\n  height: 10px;\n  width: 18px;\n  border-top: none;\n  border-radius: 2px;\n  background: rgba(168, 85, 247, 0.35);\n  border: 1px solid rgba(216, 180, 254, 0.9);\n  box-sizing: border-box;\n}\n\n.pose-angle-charts__stroke-swatch--rally {\n  height: 10px;\n  width: 18px;\n  border-top: none;\n  border-radius: 2px;\n  background: rgba(147, 51, 234, 0.55);\n  border: 1px solid #e9d5ff;\n  box-sizing: border-box;\n}\n\n.pose-angle-charts__phase-swatch {\n  height: 10px;\n  width: 18px;\n  border-radius: 2px;\n  display: inline-block;\n  flex-shrink: 0;\n  border: 1px solid rgba(248, 250, 252, 0.18);\n  background: rgba(248, 250, 252, 0.08);\n  box-sizing: border-box;\n}\n\n.pose-angle-charts__phase-swatch--preparation {\n  background: rgba(56, 189, 248, 0.18);\n  border-color: rgba(56, 189, 248, 0.68);\n}\n\n.pose-angle-charts__phase-swatch--forward {\n  background: rgba(251, 191, 36, 0.16);\n  border-color: rgba(251, 191, 36, 0.68);\n}\n\n.pose-angle-charts__phase-swatch--contact {\n  background: rgba(251, 146, 60, 0.20);\n  border-color: rgba(251, 146, 60, 0.88);\n}\n\n.pose-angle-charts__phase-swatch--follow {\n  background: rgba(255, 64, 129, 0.14);\n  border-color: rgba(255, 64, 129, 0.66);\n}\n\n.pose-angle-charts__phase-swatch--recovery {\n  background: rgba(34, 197, 94, 0.12);\n  border-color: rgba(34, 197, 94, 0.62);\n}\n\n.pose-angle-charts__empty {\n  margin: 4px 0 0;\n  font-size: 11px;\n  color: rgba(248, 250, 252, 0.5);\n}\n\n.pose-angle-charts__tooltip {\n  padding: 6px 8px;\n  border-radius: 8px;\n  background: rgba(12, 12, 16, 0.94);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  font-size: 11px;\n  color: #f8fafc;\n}\n\n.pose-angle-charts__tooltip-time {\n  margin-bottom: 4px;\n  font-weight: 600;\n  color: rgba(248, 250, 252, 0.85);\n}\n\n.pose-angle-charts__tooltip-phase {\n  margin: 0 0 6px;\n  font-weight: 700;\n  font-size: 11px;\n  letter-spacing: 0.01em;\n}\n\n.pose-angle-charts__tooltip-phase--preparation {\n  color: #7dd3fc;\n}\n\n.pose-angle-charts__tooltip-phase--forward_swing {\n  color: #fbbf24;\n}\n\n.pose-angle-charts__tooltip-phase--contact {\n  color: #fb923c;\n}\n\n.pose-angle-charts__tooltip-phase--follow_through {\n  color: #f472b6;\n}\n\n.pose-angle-charts__tooltip-phase--recovery {\n  color: #4ade80;\n}\n\n.review-video-player--embedded .pose-angle-charts {\n  max-height: min(36vh, 280px);\n}\n\n.pose-detection-metrics {\n  margin: 0 0 8px;\n  padding: 8px 10px;\n  border-radius: 10px;\n  background: rgba(15, 23, 42, 0.72);\n  border: 1px solid rgba(251, 191, 36, 0.35);\n}\n\n.pose-detection-metrics__title {\n  font-size: 12px;\n  font-weight: 650;\n  color: #fde68a;\n  margin-bottom: 6px;\n}\n\n.pose-detection-metrics__grid {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 6px;\n}\n\n.pose-detection-metrics__stat {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.pose-detection-metrics__label {\n  font-size: 9px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: rgba(248, 250, 252, 0.5);\n}\n\n.pose-detection-metrics__value {\n  font-size: 13px;\n  font-weight: 650;\n  color: #f8fafc;\n  font-variant-numeric: tabular-nums;\n}\n\n.pose-detection-metrics__hint {\n  margin: 6px 0 0;\n  font-size: 10px;\n  color: rgba(248, 250, 252, 0.45);\n  line-height: 1.35;\n}\n\n.serve-bounce-heatmap {\n  margin: 8px 0 4px;\n  border-radius: 10px;\n  overflow: hidden;\n  background: linear-gradient(180deg, rgba(8, 15, 28, 0.92), rgba(15, 23, 42, 0.88));\n  border: 1px solid rgba(148, 163, 184, 0.18);\n}\n\n.serve-bounce-heatmap__svg {\n  display: block;\n  width: 100%;\n  height: auto;\n  max-height: 140px;\n}\n\n.serve-bounce-heatmap__caption {\n  margin: 0;\n  padding: 4px 8px 8px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  color: rgba(226, 232, 240, 0.78);\n}\n\n.serve-heat-map {\n  margin: 8px 0 4px;\n  border-radius: 10px;\n  overflow: hidden;\n  background: linear-gradient(180deg, rgba(8, 15, 28, 0.92), rgba(15, 23, 42, 0.88));\n  border: 1px solid rgba(148, 163, 184, 0.18);\n}\n\n.serve-heat-map__svg {\n  display: block;\n  width: 100%;\n  height: auto;\n  max-height: 168px;\n}\n\n.serve-heat-map__floor {\n  fill: #0b1220;\n}\n\n.serve-heat-map__table {\n  fill: #1d4a38;\n  stroke: rgba(167, 243, 208, 0.55);\n  stroke-width: 1.4;\n}\n\n.serve-heat-map__stand {\n  fill: rgba(15, 23, 42, 0.35);\n}\n\n.serve-heat-map__stand--a {\n  fill: rgba(34, 211, 238, 0.08);\n}\n\n.serve-heat-map__stand--b {\n  fill: rgba(251, 113, 133, 0.08);\n}\n\n.serve-heat-map__net {\n  stroke: #f8fafc;\n  stroke-width: 1.6;\n  stroke-linecap: round;\n  opacity: 0.85;\n}\n\n.serve-heat-map__bin--a {\n  fill: #22d3ee;\n  pointer-events: none;\n}\n\n.serve-heat-map__bin--b {\n  fill: #fb7185;\n  pointer-events: none;\n}\n\n.serve-heat-map__dot circle {\n  fill: #22d3ee;\n  stroke: rgba(8, 15, 28, 0.85);\n  stroke-width: 1.2;\n  cursor: pointer;\n  outline: none;\n}\n\n.serve-heat-map__dot.is-b circle {\n  fill: #fb7185;\n}\n\n.serve-heat-map__dot.is-selected circle {\n  stroke: #fef3c7;\n  stroke-width: 2;\n  filter: drop-shadow(0 0 4px rgba(253, 230, 138, 0.8));\n}\n\n.serve-heat-map__dot circle:focus-visible {\n  stroke: #f8fafc;\n  stroke-width: 2.2;\n}\n\n.serve-heat-map__end-label {\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  pointer-events: none;\n}\n\n.serve-heat-map__end-label--a {\n  fill: #67e8f9;\n}\n\n.serve-heat-map__end-label--b {\n  fill: #fda4af;\n}\n\n.serve-heat-map__dot-ms {\n  fill: #f8fafc;\n  font-size: 9px;\n  font-weight: 700;\n  paint-order: stroke;\n  stroke: rgba(8, 15, 28, 0.85);\n  stroke-width: 2.4;\n  pointer-events: none;\n}\n\n.serve-ready-list {\n  list-style: none;\n  margin: 8px 0 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  max-height: 168px;\n  overflow-y: auto;\n}\n\n.serve-ready-list__row {\n  appearance: none;\n  width: 100%;\n  display: grid;\n  grid-template-columns: 52px 1fr auto;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 8px;\n  border-radius: 8px;\n  border: 1px solid rgba(148, 163, 184, 0.16);\n  background: rgba(8, 15, 28, 0.45);\n  color: inherit;\n  cursor: pointer;\n  text-align: left;\n}\n\n.serve-ready-list__row:hover {\n  background: rgba(8, 15, 28, 0.72);\n}\n\n.serve-ready-list__row:focus-visible {\n  outline: 2px solid #67e8f9;\n  outline-offset: 1px;\n}\n\n.serve-ready-list__row.is-a {\n  border-left: 3px solid #22d3ee;\n}\n\n.serve-ready-list__row.is-b {\n  border-left: 3px solid #fb7185;\n}\n\n.serve-ready-list__row.is-on {\n  background: rgba(251, 191, 36, 0.12);\n  border-color: rgba(251, 191, 36, 0.45);\n}\n\n.serve-ready-list__id {\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n  color: #e2e8f0;\n}\n\n.serve-ready-list__metric-label {\n  font-size: 10px;\n  color: rgba(248, 250, 252, 0.5);\n}\n\n.serve-ready-list__value {\n  font-size: 13px;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  color: #f8fafc;\n}\n\n@media (max-width: 640px) {\n  .pose-detection-metrics__grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
